import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';
import { Command } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import Code from '../../marks/Code';
import { markInputRule } from '../../utils';
import moveLeft from '../../utils/moveLeft';
import moveRight from '../../utils/moveRight';
import { INLINE_CODE_NODE_NAME, REGEX_INLINE_CODE } from './consts';
import plugins from './plugins';

export default class CodeInline extends Code {
  get name(): string {
    return INLINE_CODE_NODE_NAME;
  }

  get keys(): { [key: string]: Command } | null {
    return {
      ArrowLeft: moveLeft(),
      ArrowRight: moveRight(),
    };
  }
  parseMarkdown(): void | ParseSpec {
    return {
      mark: INLINE_CODE_NODE_NAME,
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [markInputRule(REGEX_INLINE_CODE, schema.marks.code_inline)];
  }

  plugins = plugins;
}
